
define(
	'Code25.Junior'
	, [
		"underscore", "jQuery", "Profile.Model"
	]
	, function (
		_, jQuery, ProfileModel
	) {
		'use strict';

		return {
			mount: function (container) {


				var profile = ProfileModel.getInstance();
				var contactRole = profile.get("contactRole");
				var isJunior = contactRole && contactRole.name == "Junior";
				if(isJunior){

				var body = "";
				//
				body += ".AccountBalance,.TransactionHistory,.PrintStatement,.menu-tree-node-item-anchor[data-id=\"balance\"],.menu-tree-node-item-anchor[data-id=\"transactionhistory\"],.menu-tree-node-item-anchor[data-id=\"printstatement\"]{display:none;}"

				var styleTag = document.createElement("style");

				styleTag.innerHTML = body;
				document.getElementsByTagName("head")[0].appendChild(styleTag);
				}
			}
		};

	});
